<template>
  <md-icon>
    <i :class="classObj" @click="$emit('click')" />
  </md-icon>
</template>

<script>
export default {
  props: {
    regular: Boolean,
    brands: Boolean,
    icon: String,
  },

  computed: {
    classObj() {
      const obj = {}

      if (this.regular) obj.far = true
      else if (this.brands) obj.fab = true
      else obj.fas = true

      obj[`fa-${this.icon}`] = true

      return obj
    },
  },
}
</script>
